import { Check, Cog, Droplets, Fuel, Joystick, PlugZap, Zap } from "lucide-react";
import { FUEL_FILTERS, GEARBOX_FILTERS } from "../data/quickFilters";

const ICONS = {
  diesel: Droplets,
  benzin: Fuel,
  elektro: Zap,
  hybrid: PlugZap,
  automatik: Cog,
  schaltgetriebe: Joystick
};

function countLabel(count) {
  if (count === 0) return "Keine Fahrzeuge verfügbar";
  return count === 1 ? "1 Fahrzeug" : `${count} Fahrzeuge`;
}

function FilterTile({ filter, count, active, onSelect, group }) {
  const Icon = ICONS[filter.icon];
  return (
    <button type="button" className={`brand-tile quick-tile ${active ? "is-active" : ""} ${count === 0 ? "is-empty" : ""}`} aria-pressed={active} onClick={() => onSelect(active ? "" : filter.slug)} data-testid={`${group}-tile-${filter.slug}`}>
      <span className="brand-tile-logo quick-tile-icon" aria-hidden="true"><Icon size={30} strokeWidth={1.4} /></span>
      <span className="brand-tile-name">{filter.name}</span>
      <span className="brand-tile-count" data-testid={`${group}-count-${filter.slug}`}>{countLabel(count)}</span>
      {active && <span className="brand-tile-check" aria-hidden="true"><Check size={13} strokeWidth={2.5} /></span>}
    </button>
  );
}

export default function QuickFilters({ fuel, onFuelChange, gearbox, onGearboxChange, fuelContext, gearboxContext }) {
  return (
    <div className="quick-filters" data-testid="quick-filters">
      <section className="quick-filter-group" aria-labelledby="fuel-filter-title">
        <div className="brand-section-head"><h3 id="fuel-filter-title">Nach Kraftstoff suchen</h3><span>Antriebsart antippen</span></div>
        <div className="brand-grid quick-grid quick-grid-fuel" role="group" aria-label="Kraftstoff">
          {FUEL_FILTERS.map((filter) => <FilterTile key={filter.slug} group="fuel" filter={filter} count={fuelContext.filter(filter.match).length} active={fuel === filter.slug} onSelect={onFuelChange} />)}
        </div>
      </section>
      <section className="quick-filter-group" aria-labelledby="gearbox-filter-title">
        <div className="brand-section-head"><h3 id="gearbox-filter-title">Nach Getriebe suchen</h3><span>Getriebeart antippen</span></div>
        <div className="brand-grid quick-grid quick-grid-gearbox" role="group" aria-label="Getriebe">
          {GEARBOX_FILTERS.map((filter) => <FilterTile key={filter.slug} group="gearbox" filter={filter} count={gearboxContext.filter(filter.match).length} active={gearbox === filter.slug} onSelect={onGearboxChange} />)}
        </div>
      </section>
    </div>
  );
}
